import { clearSelectedItem } from 'owa-calendar-surface';
import { enableCalendarModuleHotkeys } from '../utils/bindCalendarModuleHotKeys';
import { enableCalendarModuleContentHotkeys } from '../utils/bindCalendarModuleContentHotKeys';
import { onResetModuleCommand } from 'owa-calendar-module-command';
import { surfaceStore } from 'owa-calendar-surface-surface-store';
import { orchestrator } from 'satcheljs';
import { enableAppModuleHotkeys } from 'owa-app-module/lib/utils/moduleHotKeys';

orchestrator(onResetModuleCommand, actionMessage => {
    //re-enable the global hotkeys now that the popup is closing
    enableCalendarModuleHotkeys();
    enableCalendarModuleContentHotkeys();
    enableAppModuleHotkeys();

    // once the module command is reset, clear the selected item if at all there is still one
    clearSelectedItem(surfaceStore);
});
